export type OrdenacaoDePerfis = "atualizado" | "antigo" | "nome";

export type PerfilOrdenavel = {
  readonly username: string;
  readonly ultimaAtualizacaoEm: string | null;
};

/** Perfis sem sync ficam no fim. Empate de data cai no nome. */
export function ordenarPerfis<T extends PerfilOrdenavel>(
  perfis: readonly T[],
  ordenar: OrdenacaoDePerfis,
): T[] {
  return [...perfis].sort((a, b) => compararPerfis(a, b, ordenar));
}

function compararPerfis(
  a: PerfilOrdenavel,
  b: PerfilOrdenavel,
  ordenar: OrdenacaoDePerfis,
): number {
  if (ordenar === "nome") return peloNome(a, b);
  const da = a.ultimaAtualizacaoEm;
  const db = b.ultimaAtualizacaoEm;
  if (da === null && db === null) return peloNome(a, b);
  if (da === null) return 1;
  if (db === null) return -1;
  if (da === db) return peloNome(a, b);
  const maisNovoPrimeiro = da < db ? 1 : -1;
  return ordenar === "antigo" ? -maisNovoPrimeiro : maisNovoPrimeiro;
}

function peloNome(a: PerfilOrdenavel, b: PerfilOrdenavel): number {
  return a.username.localeCompare(b.username, "pt-BR");
}
